import { GET_ROULIST, UPDATE_ROULIST } from '../../constant';

const initRouList = [];
const rouList = (state = initRouList, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_ROULIST:
      return state;
    case UPDATE_ROULIST:
      return data;
    default:
      return state;
  }
};

export { rouList };
